import {ProductProperNames} from "../constants/ProductConstants";

export function replaceProductName(product) {
    return ProductProperNames[product] || product;
}
